export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00718.7bccf51e.png";